import React from 'react'
import PropTypes from 'prop-types'

import Notification from 'components/Notification'

import UnitComponent from './component'
import { PAGE_DISPLAY_TYPE } from './constants'
import UnitComponentEvents from './events'
import { getData, resolveLessonSummaries } from './data'
import { LMSUnitType, UnitType } from './types'

const UnitComponentContainer = ({
  acknowledgements,
  linkSummaries,
  lmsUnit,
  match,
  navigationEvent,
  onSelectUnit,
  productName,
  unit,
  unitId,
}) => {
  if (!unit) {
    return (
      <Notification color="danger">
        <h3>{`Unit ${match?.params?.unit ?? 'unknown'} not found`}</h3>
      </Notification>
    )
  }

  const isLessonPage = unit.pageDisplayType === PAGE_DISPLAY_TYPE.PAGE
  const isLessonAccordion = !isLessonPage
  const lessonSummaries = resolveLessonSummaries({
    isLessonPage,
    linkSummaries,
    unit,
  })

  const {
    advisoryActivities,
    lessonStartingIndex,
    unitVideo,
    unitName,
    lmsLessons,
    unitTabs,
  } = getData({ contentUnit: unit, currentUnitId: unitId, lmsUnit })

  const showAdditionalResources = advisoryActivities.size === 3
  const gradeTheme = match.params?.course
    ? match.params.course.replace('-', '')
    : ''
  const onAcknowledgementsClick = UnitComponentEvents.onClickAcknowledgements({
    acknowledgements,
    match,
    navigationEvent,
  })

  return (
    <UnitComponent
      acknowledgements={acknowledgements}
      gradeTheme={gradeTheme}
      isLessonAccordion={isLessonAccordion}
      lessonStartingIndex={lessonStartingIndex}
      lessonSummaries={lessonSummaries}
      lmsLessons={lmsLessons}
      match={match}
      onAcknowledgementsClick={onAcknowledgementsClick}
      onSelectUnit={onSelectUnit}
      productName={productName}
      showAdditionalResources={showAdditionalResources}
      unit={unit}
      unitId={unitId}
      unitName={unitName}
      unitTabs={unitTabs}
      unitVideo={unitVideo}
    />
  )
}

UnitComponentContainer.propTypes = {
  acknowledgements: PropTypes.object,
  linkSummaries: PropTypes.array,
  lmsUnit: LMSUnitType,
  match: PropTypes.object.isRequired,
  navigationEvent: PropTypes.func,
  onSelectUnit: PropTypes.func.isRequired,
  productName: PropTypes.string,
  unit: UnitType,
  unitId: PropTypes.string,
}

export default UnitComponentContainer
